module.exports = __webpack_public_path__ + "static/media/icon_youtube.74a210a4.svg";